import { ColumnDef } from "@tanstack/react-table";
import { User } from "@/endpoints/dryp/user";

export const USER_BASE_COLUMNS: ColumnDef<User>[] = [
	{
		accessorKey: "userName",
		header: "Username",
	},
	{
		accessorKey: "email",
		header: "Email",
	},
	{
		accessorKey: "roleName",
		header: "Role",
		enableSorting: false,
	},
];
